export enum EAnalyticSource {
  SESSIONS = 'sessions',
  SALES = 'sales',
}
